import "./Offer.module.css";
import Navigation from "@/reusable_sections/Header";
import Construction from "./sections/Construction";
import Standards from "./sections/Standards";
import Brukarstwo from "./sections/Brukarstwo";
import Footer from "@/reusable_sections/Footer";
export default function OfferPage() {
  return <div>
      <Navigation />
      <Construction />
      <Standards />
      <Brukarstwo />
      <Footer />
    </div>;
}